export const $e = {
  system: {
    booted: true,

    needs: {
      approval: true,
      reload: true,
      configReload: true,
      notificationPermission: true,
      tour: true,
      pin: true,
      search: true,
      notificationCount: true,
    },

    has: {
      notificationPermission: true,
      notification: true,
      confirmation: true,
    },
  },

  echo: {
    OrderStatusChanged: true,
    OrderUpdated: true,
  },

  app: {
    loaded: true,
    loadFailed: true,
    reloaded: true,

    mainActionPrompt: {
      shown: true,
      hidden: true,
    },

    indicator: {
      process: {
        start: true,
        end: true,
      },
    },

    needs: {
      search: true,
      mainActionPrompt: true,

      to: {
        scrollToTop: true,
        askForPermission: true,
        closeMainActionPrompt: true,
      },
    },

    messages: {
      noRelatedProducts: true,
      relatedProductsFound: true,
    },
  },

  ui: {
    not: {
      need: {
        actionsForm: true,
      },
    },

    needs: {
      offcanvas: {
        nav: true,
      },
      loginForm: true,
      actionsForm: true,
    },
  },

  business: {
    needs: {
      location: true,
    },
  },

  user: {
    authenticated: true,
    loggedOut: true,
    updated: true,

    needs: {
      update: true,
      temporaryAvr: true,
      quickUpdate: true,
      fcmTokenUpdate: true,
      addressForm: true,
      authentication: true,
      registration: true,
      emailLogin: true,
      googleLogin: true,
      appleLogin: true,
      logout: true,
      information: true,

      to: {
        selectLogisticsCompany: true,
        seePin: true,
        registerBusiness: true,
      },

      password: {
        reset: true,
        link: true,
        change: true,
      },

      referFriend: true,
      referFriendMedia: true,
      profileModal: true,
      authCheck: true,
      transfers: true,
    },

    has: {
      emailLoginError: true,
      information: true,
      fcmToken: true,
      updateError: true,
      logoutError: true,
      registrationError: true,
    },

    profilePicture: {
      changed: true,

      needs: {
        change: true,
        storage: true,
        pictureForm: true,
      },

      has: {
        storageError: true,
      },
    },
  },

  location: {
    is: {
      needed: true,
      available: true,
      decoded: true,
    },
    needs: {
      decode: true,
    },
    has: {
      decodeError: true,
    },
  },

  map: {
    needs: {
      interface: true,
    },

    has: {
      location: true,
    },
  },

  order: {
    statusChanged: true,
    deleted: true,

    needs: {
      refresh: true,
      businessOrders: true,
      markAsReady: true,
      markAsProcessing: true,
    },

    has: {
      businessOrders: true,
      updatedStatus: true,
    },
  },

  review: {
    stored: true,
    updated: true,
    deleted: true,

    needs: {
      creation: true,
      update: true,
      deletion: true,
      reviewForm: true,
      storage: true,
    },

    has: {
      storageError: true,
    },
  },

  deliveryAddress: {
    chosen: true,
    selected: true,
    stored: true,
    deleted: true,

    needs: {
      deletion: true,
      addressForm: true,
      storage: true,
      allAddresses: true,
    },

    has: {
      storageError: true,
      deletionError: true,
      allAddresses: true,
    },
  },

  deliveryRequest: {
    needs: {
      requestForm: true,
      closeRequestForm: true,
    },
  },

  typicalProduct: {
    needs: {
      view: true,
    },
  },

  product: {
    stored: true,
    deleted: true,

    needs: {
      deletion: true,
      creation: true,
      productForm: true,
      storage: true,
      allItems: true,
      update: true,
    },

    has: {
      storageError: true,
      deletionError: true,
    },
  },

  payment: {
    stored: true,
    failed: true,
    completed: true,

    needs: {
      creation: true,
      collection: true,
    },

    has: {
      processingError: true,
    },
  },

  analytics: {
    loaded: true,
    needs: {
      event: true,
    },
  },

  capa: {
    deposited: true,
    transferred: true,

    needs: {
      deposit: true,
      depositForm: true,
      purchase: true,
      payment: true,
      balance: true,
      transfer: true,
      transferForm: true,
      to: {
        initiateTransfer: true,
      },
    },

    is: {
      depositing: true,
    },

    has: {
      depositError: true,
      balance: true,
      transferError: true,
    },
  },

  aiCredit: {
    deposited: true,

    needs: {
      deposit: true,
      depositForm: true,
      purchase: true,
      payment: true,
      balance: true,
    },

    is: {
      depositing: true,
    },

    has: {
      depositError: true,
      balance: true,
    },
  },

  // Business voice call - "manage my catalog by voice" (Yoca for
  // Business). Reuses the exact same event names as app.carata's
  // customer-facing voice-order feature (see that app's ojs.events.js)
  // so both apps' call widgets follow the same flow - see
  // src/mediators/BusinessVoiceOrderCall.js and
  // src/components/Modals/BusinessVoiceOrderCallModal.js.
  voiceOrderCall: {
    needs: {
      start: true,
      end: true,
      // Fired by BusinessVoiceOrderCallModal.js's speaker toggle button -
      // native-only (no-op on web, see BusinessVoiceOrderCallClient.
      // setSpeakerphoneOn()'s docblock).
      setSpeakerphoneOn: true,
    },

    has: {
      statusChanged: true,
      transcript: true,
      toolCalled: true,
      heartbeat: true,
      audioLevel: true,
      ended: true,
      error: true,
      // Native proximity sensor forced the speakerphone off - see
      // BusinessVoiceOrderCallClient's "speakerphonechanged" event.
      speakerphoneChanged: true,
    },
  },

  setting: {
    updated: true,

    needs: {
      information: true,
      update: true,
    },

    has: {
      information: true,
    },
  },

  qr: {
    needs: {
      scan: true,
      creation: true,
      scanForm: true,
      resultHandling: true,
      code: true,
    },

    has: {
      visibleForm: true,
      scanResult: true,
    },
  },

  image: {
    needs: {
      view: true,
    },
  },

  logisticsCompany: {
    needs: {
      form: true,
    },
    is: {
      selected: true,
    },
  },

  errand: {
    task: {
      needs: {
        completion: true,
        completionForm: true,
      },
      has: {
        completionError: true,
      },
      is: {
        completed: true,
      },
    },

    is: {
      requested: true,
    },

    needs: {
      request: true,
      creation: true,

      to: {
        removeTask: true,
      },
    },
    has: {
      requestError: true,
    },
  },

  announcement: {
    was: {
      clicked: true,
    },
  },

  company: {
    updated: true,

    needs: {
      update: true,
    },

    has: {
      updateError: true,
      changed: true,
    },

    staff: {
      deleted: true,
      created: true,

      needs: {
        deletion: true,
        creation: true,
      },

      has: {
        deletionError: true,
        creationError: true,
      },

      invitation: {
        cancelled: true,
        created: true,

        needs: {
          cancellation: true,
          creation: true,
        },

        has: {
          cancellationError: true,
          creationError: true,
        },
      },
    },
  },
  
  service: {
    created: true,
    deleted: true,
    updated: true,

    needs: {
      deletion: true,
      creation: true,
      update: true,
    },

    has: {
      deletionError: true,
      creationError: true,
      updateError: true,
    },
  },
  
  deal: {
    deleted: true,
    productRemoved: true,

    needs: {
      deletion: true,
      productRemoval: true,
    },

    has: {
      deletionError: true,
      productRemovalError: true,
    },
  },
  
  branch: {
    created: true,
    deleted: true,
    updated: true,

    needs: {
      deletion: true,
      creation: true,
      update: true,
      toggleOnline: true,
      bulkToggleOnline: true,
    },

    has: {
      deletionError: true,
      creationError: true,
      updateError: true,
    },

    staff: {
      deleted: true,
      created: true,

      needs: {
        deletion: true,
        creation: true,
      },

      has: {
        deletionError: true,
        creationError: true,
      },

      invitation: {
        cancelled: true,
        created: true,

        needs: {
          cancellation: true,
          creation: true,
        },

        has: {
          cancellationError: true,
          creationError: true,
        },
      },
    },
  },

  termsAndConditions: {
    accepted: true,
    declined: true,

    needs: {
      acceptance: true,
    },
  },

  appReview: {
    needs: {
      prompt: true,
      rateNow: true,
      remindLater: true,
    },

    shown: true,
    dismissed: true,
  },

  homescreenGuide: {
    needs: {
      // Show the "Add to Home Screen" steps modal (iOS).
      prompt: true,
    },
  },

  featureAnnouncements: {
    needs: {
      // Queue up (and show, if nothing is currently showing) one or
      // more "what's new" feature-announcement walkthroughs.
      // Payload: { featureAnnouncements }
      prompt: true,
    },

    shown: true,
    dismissed: true,
  },
};
